import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CompanyContextService } from './company-context.service';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const tenantId = inject(CompanyContextService).selected()?.tenantId;

  if (!tenantId) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { 'X-Tenant-ID': tenantId } }));
};
